<template>
  <widgetModal :title="saveAs ? `Save as template` : form_form.id ? `Edit template` : `Add New template`"
    :subtitle="saveAs ? `Please note that before saving the questionaire as a template, it's important to review and remove any private or confidential information that may not be suitable for reuse.` : `Fill in the details below for template.`"
    btnlefttext="Save" btncentertext="Cancel" :leftloading="survey_loading" :hiderightbtn="true" :centerloading="false"
    :footerhidden="false" footer_padding="20px 20px" header_padding="20px 20px" body_padding="0px 20px" width="700px"
    @onLeftClick="addNewTemplate()" @onCenterClick="onCancel()">

    <div class="widget-modal-body-noscoll">
      <widgetInputWrapper title="Title">
        <widgetInput v-model="form_form.title" type="text" placeholder="Add Title"></widgetInput>
      </widgetInputWrapper>

      <widgetInputWrapper title="Description">
        <widgetTextarea v-model="form_form.description" placeholder="Add Description"></widgetTextarea>
      </widgetInputWrapper>

      <widgetInputWrapper title="Type">
        <widgetSelect v-model="form_form.type" :opt="[
          { label: 'Students', value: 'students' },
          { label: 'Companies', value: 'companies' },
        ]" placeholder="Select type"></widgetSelect>
      </widgetInputWrapper>

      <widgetInputWrapper title="Questions">
        <div class="question-widget">
          <div class="question-item" v-for="(item, index) in question_form" :key="index">
            <div class="question-form-widget">
              <!-- Question widget -->
              <div class="question-form" v-if="item.section_type == 'question'">
                <div class="question-header">
                  <widgetInput v-model="item.ask" type="text" placeholder="Enter question"></widgetInput>
                  <questionInputWidget :type="type == 'evaluation' ? 'form' : 'survey'" v-model="item.question_type">
                  </questionInputWidget>
                </div>
                <div class="question-body">
                  <div v-if="item.question_type == 'short_answer'" class="solution-type short_answer">
                    Short answer text
                  </div>
                  <div v-if="item.question_type == 'paragraph'" class="solution-type paragraph_answer">
                    Long answer text
                  </div>
                  <div v-if="item.question_type == 'multiple_choice' ||
                    item.question_type == 'checkboxes' ||
                    item.question_type == 'dropdown'
                    " class="solution-type choice_answer">
                    <div class="choice-item" v-for="(option, i) in item.choice_options" :key="i">
                      <span v-if="item.question_type == 'dropdown'">{{ i + 1 }}.
                      </span>
                      <input v-if="item.question_type == 'multiple_choice'" readonly type="radio" />
                      <input v-if="item.question_type == 'checkboxes'" readonly type="checkbox" />
                      <input v-model="option.name" placeholder="Add Option" class="choice-label" type="text" />
                      <button @click="removeOption(item, i)" class="btn-option-remove">
                        &times;
                      </button>
                    </div>
                    <div class="choice-item">
                      <button @click="addOption(item)" class="btn-add">
                        + Add Option
                      </button>
                    </div>
                  </div>
                  <div v-if="item.question_type == 'file_upload'" class="solution-type file_upload">
                    File upload answer
                  </div>
                  <div v-if="item.question_type == 'date'" class="solution-type date">
                    <span>Month, day, year</span>
                    <img src="@/assets/question-icon/calendar.svg" alt="" />
                  </div>
                  <div v-if="item.question_type == 'time'" class="solution-type time">
                    <span>Time</span>
                    <img src="@/assets/question-icon/clock.svg" alt="" />
                  </div>
                </div>
              </div>

              <!-- Title & Section-->
              <div class="question-form" v-if="item.section_type == 'title' ||
                item.section_type == 'section'
                " :class="{ section_widget: item.section_type == 'section' }">
                <div class="section-label">Section</div>
                <div class="section-title-header">
                  <input type="text" v-model="item.title" placeholder="Enter title" class="input-form" />
                </div>
                <div class="question-body">
                  <textarea class="input-form title-section-widget-description" v-model="item.description"
                    placeholder="Desription (optional)"></textarea>
                </div>
              </div>

              <!-- Image -->
              <div class="question-form image_widget" v-if="item.section_type == 'image'">
                <div class="section-title-header">
                  <input type="text" v-model="item.title" placeholder="Enter image title" class="input-form" />
                </div>
                <div class="question-body">
                  <div class="image-container">
                    <img class="selected_image" v-if="item.file_blob" :src="item.file_blob_url" />
                    <img class="selected_image" v-else-if="item.file_name" :src="$fullUrl('images/' + item.file_name)" />
                    <button @click="addImageAgain(index)" class="btn-reselect" v-if="item.file_blob">
                      Reselect Image
                    </button>
                    <button @click="addImageAgain(index)" class="btn-reselect" v-else>
                      Add Image
                    </button>
                  </div>
                </div>
              </div>

              <!-- Video -->
              <div class="question-form image_widget" v-if="item.section_type == 'video'">
                <div class="section-title-header">
                  <input type="text" v-model="item.title" placeholder="Enter video title" class="input-form" />
                </div>
                <div class="question-body">
                  <div class="video-container">
                    <video class="selected_video" v-if="item.file_blob" :src="item.file_blob_url" controls></video>
                    <video class="selected_video" v-else-if="item.file_name" :src="$fullUrl('images/' + item.file_name)"
                      controls></video>
                    <button @click="addVideoAgain(index)" class="btn-reselect" v-if="item.file_blob">
                      Reselect Video
                    </button>
                    <button @click="addVideoAgain(index)" class="btn-reselect" v-else>
                      Add Video
                    </button>
                  </div>
                </div>
              </div>
              <input type="file" :id="'row_' + index + 'survey-file-input'" @change="onGetSurveyFile($event, item)"
                style="display: none" />
              <button class="btn-remove" v-if="index < question_form.length - 1" @click="removeQuestion(index)">
                Remove
              </button>
              <div class="option" v-if="index == question_form.length - 1">
                <button @click="addQuestion('question', index)" class="btn-add">
                  <img src="@/assets/question-icon/new.svg" /> New
                </button>
                <button v-if="false" @click="addQuestion('import', index)" class="btn-add">
                  <img src="@/assets/question-icon/import.svg" /> Import
                </button>
                <button @click="addQuestion('title', index)" class="btn-add">
                  <img src="@/assets/question-icon/title.svg" /> Title
                </button>
                <button @click="addQuestion('image', index)" class="btn-add">
                  <img src="@/assets/question-icon/image.svg" /> Image
                </button>
                <button @click="addQuestion('video', index)" class="btn-add">
                  <img src="@/assets/question-icon/video.svg" /> Video
                </button>
                <button @click="addQuestion('section', index)" class="btn-add">
                  <img src="@/assets/question-icon/section.svg" /> Section
                </button>
                <button class="btn-remove" v-if="index != 0 && index == question_form.length - 1"
                  @click="removeQuestion(index)">
                  Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      </widgetInputWrapper>
    </div>
  </widgetModal>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    value: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: "evaluation",
    },
    phase: {
      type: String,
      default: "",
    },
    saveAs: {
      type: Boolean,
      default: false
    },
  },
  data: () => {
    return {
      form_form: {
        id: null,
        title: "",
        type: "students",
        form_type: "",
        description: "",
        questions: "",
        phase: ""
      },
      question_form: [
        {
          ask: "",
          section_type: "question",
          question_type: "short_answer",
          title: "Untitled Title",
          file_name: "",
          description: "",
          file_blob: null,
          file_blob_url: "",
          choice_options: [
            {
              name: "Option 1",
              value: 0,
            },
          ],
        },
      ],
      survey_loading: false,
    };
  },
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.setFormFields(vm.value);
    } else {
      vm.resetFormFields();
    }
  },
  computed: {},
  watch: {},
  methods: {
    setFormFields(item) {
      let vm = this;
      vm.form_form.id = item.id;
      vm.form_form.title = item.title;
      vm.form_form.type = item.type;
      vm.form_form.form_type = item.form_type;
      vm.form_form.description = item.description;
      vm.question_form = JSON.parse(item.questions).map((item) => {
        item.file_blob = null;
        item.file_blob_url = null;
        return item;
      });
    },
    resetFormFields() {
      let vm = this;
      vm.form_form = {
        id: null,
        title: "",
        type: "students",
        form_type: "",
        description: "",
        questions: "",
        phase: ""
      };
      vm.question_form = [
        {
          ask: "",
          section_type: "question",
          question_type:
            vm.type == "evaluation" ? "checkboxes" : "short_answer",
          title: "Untitled Title",
          file_name: "",
          file_blob: null,
          file_blob_url: "",
          description: "",
          choice_options: [
            {
              name: "Option 1",
              value: 0,
            },
          ],
        },
      ];
    },
    addNewTemplate() {
      let vm = this;
      vm.survey_loading = true;
      vm.form_form.form_type = vm.type;
      let file_to_upload = [];
      vm.question_form.forEach((item) => {
        if (item.section_type == "image" || item.section_type == "video") {
          if (item.file_blob) {
            file_to_upload.push(item);
          }
        }
        return item;
      });
      if (file_to_upload.length > 0) {
        vm.uploadSurveyFile(file_to_upload);
      } else {
        vm.saveTemplateSurvey();
      }
    },
    uploadSurveyFile(files) {
      let vm = this;
      let form_data = new FormData();
      files.forEach((item) => {
        form_data.append("files[]", item.file_blob, item.file_name);
      });
      vm.$store
        .dispatch("UPLOAD_MILTIPLE_FILE", form_data)
        .then((value) => {
          vm.saveTemplateSurvey();
        })
        .catch((reason) => {
          vm.survey_loading = false;
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    saveTemplateSurvey() {
      let vm = this;
      vm.survey_loading = true;
      vm.form_form.questions = JSON.stringify(vm.question_form);
      if (!vm.form_form.id) {
        vm.form_form.phase = vm.phase;
        vm.$store
          .dispatch("COMMUNICATION_QUESTIONAIRE_SAVE_TEMPLATE", vm.form_form)
          .then((responce) => {
            vm.survey_loading = false;
            vm.$emit("saved", vm.form_form);
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Template is now saved",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.survey_loading = false;
            vm.$notify({
              group: "status",
              title: "Warning",
              text: "Something wrong while saving",
              type: "warn",
              duration: 3000,
            });
          });
      } else {
        vm.$store
          .dispatch("COMMUNICATION_QUESTIONAIRE_UPDATE_TEMPLATE", vm.form_form)
          .then((responce) => {
            vm.survey_loading = false;
            vm.$emit("saved");
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Template is now updated",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.survey_loading = false;
            vm.$notify({
              group: "status",
              title: "Warning",
              text: "Something wrong while updating",
              type: "warn",
              duration: 3000,
            });
          });
      }
    },
    addOption(item) {
      let vm = this;
      let index = item.choice_options.length;
      item.choice_options.push({
        name: "Option " + (index + 1),
        value: index + 1,
      });
    },
    removeOption(item, i) {
      let vm = this;
      item.choice_options.splice(i, 1);
    },
    removeQuestion(index) {
      let vm = this;
      vm.question_form.splice(index, 1);
    },
    addImageAgain(index) {
      document.querySelector("#row_" + index + "survey-file-input").click();
    },
    addVideoAgain(index) {
      document.querySelector("#row_" + index + "survey-file-input").click();
    },
    onGetSurveyFile({ target }, item) {
      item.file_blob = target.files[0];
      item.file_name = Date.now() + target.files[0].name;
      item.file_blob_url = URL.createObjectURL(target.files[0]);
    },
    addQuestion(type, index) {
      let vm = this;
      if (type == "question") {
        vm.question_form.push({
          ask: "",
          section_type: type,
          question_type:
            vm.type == "evaluation" ? "checkboxes" : "short_answer",
          title: "Untitled Title",
          file_name: "",
          file_blob: null,
          file_blob_url: "",
          description: "",
          choice_options: [
            {
              name: "Option 1",
              value: 0,
            },
          ],
        });
      }
      if (type == "title") {
        vm.question_form.push({
          ask: "",
          section_type: type,
          question_type: "short_answer",
          title: "Untitled Title",
          file_name: "",
          file_blob: null,
          file_blob_url: "",
          description: "",
          choice_options: [
            {
              name: "Option 1",
              value: 0,
            },
          ],
        });
      }
      if (type == "section") {
        vm.question_form.push({
          ask: "",
          section_type: type,
          question_type: "short_answer",
          title: "Untitled Section",
          file_name: "",
          file_blob: null,
          file_blob_url: "",
          description: "",
          choice_options: [
            {
              name: "Option 1",
              value: 0,
            },
          ],
        });
      }

      if (type == "image") {
        vm.question_form.push({
          ask: "",
          section_type: type,
          question_type: "short_answer",
          title: "Image Title",
          file_name: "",
          file_blob: null,
          file_blob_url: "",
          description: "",
          choice_options: [
            {
              name: "Option 1",
              value: 0,
            },
          ],
        });
        setTimeout(() => {
          let file_el = document.querySelector(
            "#row_" + (index + 1) + "survey-file-input"
          );
          file_el.accept = "image/*";
          file_el.click();
        }, 500);
      }
      if (type == "video") {
        vm.question_form.push({
          ask: "",
          section_type: type,
          question_type: "short_answer",
          title: "Video Title",
          file_name: "",
          file_blob: null,
          file_blob_url: "",
          description: "",
          choice_options: [
            {
              name: "Option 1",
              value: 0,
            },
          ],
        });
        setTimeout(() => {
          let file_el = document.querySelector(
            "#row_" + (index + 1) + "survey-file-input"
          );
          file_el.accept = "video/*";
          file_el.click();
        }, 500);
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.widget-modal-body-noscoll {
  width: 100%;

  .question-widget {
    width: 100%;
    display: flex;
    flex-direction: column;

    .question-item {
      display: flex;
      align-items: center;
      width: 100%;
      margin-bottom: 20px;

      .question-form-widget {
        width: 100%;
        display: grid;
        grid-template-columns: calc(98% - 80px) 80px;
        grid-gap: 10px;

        .question-form {
          padding: 6px;
          background: #f0f0f0;
          border-radius: 5px;

          .section-label {
            display: none;
          }

          &.section_widget {
            position: relative;
            margin-top: 30px;
            border-left: 4px solid #28a5a5;

            .section-label {
              display: block;
              position: absolute;
              top: -28px;
              background: #28a5a5;
              color: #fff;
              padding: 7px 21px;
              left: -4px;
              border-top-left-radius: 5px;
              border-top-right-radius: 5px;
            }
          }

          .question-header {
            display: grid;
            width: 100%;
            grid-template-columns: calc(90% - 150px) 150px;
            grid-gap: 9px;
          }

          .section-title-header {
            width: 100%;

            .input-form {
              width: 100%;
            }
          }

          .question-body {
            padding: 10px 20px;

            .title-section-widget-description {
              width: 100%;
            }

            .solution-type {
              &.short_answer {
                padding: 8px 0px;
                border-bottom: 1px dashed #ddd;
                color: rgb(131, 131, 131);
              }

              &.paragraph_answer {
                padding: 8px 0px;
                border-bottom: 1px dashed #ddd;
                color: rgb(131, 131, 131);
              }

              &.file_upload {
                border: 1px dashed #ddd;
                padding: 30px;
                color: rgb(131, 131, 131);
              }

              &.date {
                display: flex;
                align-items: center;
                border: 1px dashed #ddd;
                width: 300px;
                padding: 20px;

                span {
                  margin-right: 10px;
                  color: rgb(131, 131, 131);
                }
              }

              &.time {
                display: flex;
                align-items: center;
                border: 1px dashed #ddd;
                width: 300px;
                padding: 20px;

                span {
                  margin-right: 10px;
                  color: rgb(131, 131, 131);
                }
              }

              &.choice_answer {
                .choice-item {
                  display: flex;
                  align-items: center;
                  margin-bottom: 10px;

                  .choice-label {
                    background: #ddd;
                    border-radius: 5px;
                    padding: 10px 8px;
                    height: 40px;
                    width: 100%;
                    margin-left: 8px;
                  }

                  .btn-option-remove {
                    margin-left: 10px;
                    height: 40px;
                    width: 40px;
                    border: 1px solid#229EA5;
                    border-radius: 5px;
                    color: #229ea5;
                    font-size: 15px;
                  }

                  .btn-add {
                    margin-top: 15px;
                  }
                }
              }
            }

            .image-container {
              display: flex;
              flex-direction: column;
              align-items: center;

              .selected_image {
                width: 100%;
              }

              .btn-reselect {
                margin-top: 20px;
                height: 40px;
                width: 200px;
                border: 1px solid#229EA5;
                border-radius: 5px;
                color: #229ea5;
              }
            }

            .video-container {
              display: flex;
              flex-direction: column;
              align-items: center;

              .selected_video {
                width: 100%;
              }

              .btn-reselect {
                margin-top: 20px;
                height: 40px;
                width: 200px;
                border: 1px solid#229EA5;
                border-radius: 5px;
                color: #229ea5;
              }
            }
          }
        }

        .btn-remove {
          height: 35px;
          border: 1px solid #1ba5a4;
          color: #1ba5a4;
          border-radius: 5px;
          margin-top: 6px;
        }

        .option {
          background: #ffff;
          padding: 5px;
          width: 100px;
          height: 211px;
          border-radius: 5px;
          display: flex;
          flex-direction: column;

          .btn-add {
            color: #000;
            display: flex;
            align-items: center;
            padding: 8px 10px;
            width: 100%;
            border-radius: 5px;

            &:hover {
              background: #f2f4f8;
            }

            img {
              margin-right: 7px;
            }
          }
        }
      }
    }
  }
}
</style>


